<template>
  <AppHeader>Create Vacation</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Customer</p>
        <CustomerSearch v-model="form.customer_id" :customers="customers" autofocus></CustomerSearch>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.customer_id">{{ errors.customer_id }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Start Date</p>
        <input class="w-full text-xl placeholder:text-lg" v-model="form.start_date" name="start_date" type="date" :min="tom" placeholder="Select Start Date">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.start_date">{{ errors.start_date }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">End Date</p>
        <input class="w-full text-xl placeholder:text-lg" v-model="form.end_date" name="end_date" type="date" :min="form.start_date" placeholder="Select End Date">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.end_date">{{ errors.end_date }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Notes</p>
        <textarea class="w-full text-xl placeholder:text-lg" v-model="form.notes" name="notes" placeholder="Enter Notes"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.notes">{{ errors.notes }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createVacation">Create Vacation</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import CustomerSearch from '@/components/common/CustomerSearch.vue';

export default {
  name: 'CreateVacation',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading, CustomerSearch },
  data() {
    return {
      state: 'loading',
      tom: null,
      customers: [],
      form: { customer_id: '' },
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'vacations/prepare', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.customers = resp.data.customers;
      });
    },

    createVacation() {
      let rules = {
        customer_id: 'required|numeric',
        start_date: 'required|date',
        end_date: 'required|date',
        notes: '',
      };

      if (!this.validateForm(this.form, rules)) return;
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      this.request('POST', 'vacations', this.form, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        if (resp.success) this.form = { customer_id: this.$route.query.customer_id ? this.$route.query.customer_id : '', type: 'one' };
      });
    },
  },

  created() {
    let d = new Date();
    d.setDate(d.getDate() + 1);

    if (d.getHours() >= 19 && d.getMinutes() >= 1) d.setDate(d.getDate() + 1);

    this.tom = d.toISOString().substr(0, 10);
    this.form.start_date = d.toISOString().substr(0, 10);
    this.form.end_date = d.toISOString().substr(0, 10);
    if (this.$route.query.customer_id) this.form.customer_id = this.$route.query.customer_id;
    this.getData();
  }
}
</script>
